<template>
    <div
        class  = "pa-2 pr-1 pb-3 navigation-entries"
        :class = "compact ? ' pl-3' : ' pl-2'"
    >
        <!-- fab button -->
        <div
            class  = "navigation-fab"
            :style = "fabPosition"
        >
            <v-btn
                color       = "primary"
                :ripple     = "false"
                @click.stop = "onCompact"
                fab
                x-small
                absolute
                bottom
                left
            >
                <v-icon>{{ fabIcon }} </v-icon>
            </v-btn>
        </div>
        <!-- fab button -->

        <div class="v-flex mt-1 mr-4 mb-3">
            <div class="pt-3 pl-2 step-name" v-if="compact">
                {{ stepName }}
            </div>

            <v-spacer v-if="compact" />

            <div :class="compact ? '' : 'w-100'">
                <v-text-field
                    v-model   = "search"
                    class     = "mb-2 ml-2 mt-0 pt-1"
                    :outlined = "compact"
                    :style    = "searchWidth"
                    @input    = "onSearch"
                    dense
                    hide-details
                >
                    <template v-slot:prepend-inner>
                        <v-icon v-if="compact" size="20" class="ml-2" style="margin-top: 2px">mdi-magnify</v-icon>
                    </template>
                    <template v-slot:append>
                        <v-icon v-if="!compact" size="20" class="ml-2" style="margin-top: 2px">mdi-magnify</v-icon>
                    </template>
                </v-text-field>
            </div>
        </div>

        <div class="scroll-area">
            <div v-if="!compact">
                <a
                    v-for  = "(unit, index) in filteredSites"
                    :key   = "unit.id"
                    @click = "onSelect(unit)"
                >
                    <v-hover v-slot="{ hover }" >
                        <p-inc-navigation-entry
                            class     = "mr-1 mb-2 ml-2"
                            :class    = "index < filteredSites.length-1 ? 'mb-1 ' : ' '"
                            :incident = "incident"
                            :unit     = "unit"
                            :hover    = "hover"
                            @remove   = "onRemove"
                        />
                    </v-hover>
                </a>
            </div>

            <div
                v-if   = "compact"
                :style = "'height: ' + (35 + sites.length * 40) + 'px;'"
            >
                <p-inc-navigation-entry-invoice
                    v-if    = "isInvoice"
                    :header = "true"
                />

                <p-inc-navigation-entry-issue
                    v-if    = "isIssue"
                    :header = "true"
                />

                <p-inc-navigation-entry-repair
                    v-if    = "isRepair"
                    :header = "true"
                />

                <p-inc-navigation-entry-assessment
                    v-if    = "isAssessment"
                    :header = "true"
                />

                <p-inc-navigation-entry-assessment-invoice
                    v-if    = "isAssessmentInvoice"
                    :header = "true"
                />

                <a
                    v-for  = "(unit, index) in filteredSites"
                    :key   = "unit.id"
                    @click = "onSelect(unit)"
                >
                     <p-inc-navigation-entry-invoice
                        v-if        = "isInvoice"
                        class       = "ma-0 pa-0 mr-1 ml-2"
                        :entry      = "entry(unit, step)"
                        :removeable = "incident.data.length > 0"
                        :border-type="borderType(index)"
                        @remove     = "onRemove"
                    />

                    <p-inc-navigation-entry-issue
                        v-if        = "isIssue"
                        class       = "ma-0 pa-0 mr-1 ml-2"
                        :entry      = "entry(unit, step)"
                        :removeable = "incident.data.length > 0"
                        :border-type="borderType(index)"
                        @remove     = "onRemove"
                    />

                    <p-inc-navigation-entry-maintenance
                        v-if        = "isMaintenance"
                        class       = "ma-0 pa-0 mr-1 ml-2"
                        :step-data  = "stepData(step)"
                        :entry      = "entry(unit, step)"
                        :removeable = "incident.data.length > 0"
                        :border-type="borderType(index)"
                        @remove     = "onRemove"
                    />

                    <p-inc-navigation-entry-repair
                        v-if        = "isRepair"
                        class       = "ma-0 pa-0 mr-1 ml-2"
                        :entry      = "entry(unit, step)"
                        :bid        = "bid(unit, step)"
                        :removeable = "incident.data.length > 0"
                        :border-type="borderType(index)"
                        @remove     = "onRemove"
                    />

                    <p-inc-navigation-entry-assessment
                        v-if        = "isAssessment"
                        class       = "ma-0 pa-0 mr-2 ml-2"
                        :entry      = "entry(unit, step)"
                        :removeable = "incident.data.length > 0"
                        :border-type="borderType(index)"
                        @remove     = "onRemove"
                    />

                    <p-inc-navigation-entry-assessment-invoice
                        v-if        = "isAssessmentInvoice"
                        class       = "ma-0 pa-0 mr-1 ml-2"
                        :entry      = "entry(unit, step)"
                        :removeable = "incident.data.length > 0"
                        :border-type="borderType(index)"
                        @remove     = "onRemove"
                    />
                </a>
            </div>
        </div>
     </div>
</template>

<script>

import Core                                 from "@/modules/core/service/Core";
import Inc                                  from "@/modules/inc/service/Inc";
import PIncNavigationEntryAssessmentInvoice from "@/modules/inc/steps/components/navigation/private/PIncNavigationEntryAssessmentInvoice.vue";
import PIncNavigationEntry                  from "@/modules/inc/steps/components/navigation/private/PIncNavigationEntry.vue";
import PIncNavigationEntryInvoice           from "@/modules/inc/steps/components/navigation/private/PIncNavigationEntryInvoice.vue";
import PIncNavigationEntryAssessment        from "@/modules/inc/steps/components/navigation/private/PIncNavigationEntryAssessment.vue";
import PIncNavigationEntryIssue             from "@/modules/inc/steps/components/navigation/private/PIncNavigationEntryIssue.vue";
import PIncNavigationEntryRepair            from "@/modules/inc/steps/components/navigation/private/PIncNavigationEntryRepair.vue";
import PIncNavigationEntryMaintenance
    from "@/modules/inc/steps/components/navigation/private/PIncNavigationEntryMaintenance.vue";

export default {
    name: "CIncEntryMenuContent",

    components: {
        PIncNavigationEntryMaintenance,
        PIncNavigationEntryRepair,
        PIncNavigationEntryIssue,
        PIncNavigationEntryAssessment,
        PIncNavigationEntryInvoice,
        PIncNavigationEntry,
        PIncNavigationEntryAssessmentInvoice,
    },

    props: {
        incident: {

        },

        sites: {

        },

        step: {

        }
    },

    data: () => ({
        showSelection: false,
        compact      : true,
        filteredSites: [],
        search       : null,
    }),

    computed: {
        stepName () {
            if (!this.incident) {
                return "---";
            }

            return this.incident.data[this.step].stepName;
        },

        fabPosition () {
            return this.compact ? 'right: 68px; bottom: 28px' : 'right: 68px; bottom: 35px';
        },

        fabIcon () {
            return this.compact ? 'mdi-arrow-expand-vertical' : 'mdi-arrow-collapse-vertical';
        },

        searchWidth () {
            return this.compact ? 'width: 250px' : 'width: 100%';
        },

        isInvoice () {
            return this.incident.data[this.step].clazz === 'StepDataInvoiceCollectionDto' && this.incident.typeId !== Inc.type.assessmentinvoice;
        },

        isAssessmentInvoice () {
            return this.incident.data[this.step].clazz === 'StepDataInvoiceCollectionDto' && this.incident.typeId === Inc.type.assessmentinvoice;
        },

        isRepair () {
            return this.incident.data[this.step].clazz === 'StepDataRepairDto';
        },

        isAssessment () {
            return this.incident.data[this.step].clazz === 'StepDataAssesmentDto'
        },

        isIssue () {
            return this.incident.data[this.step].clazz === 'StepDataGeneralDto'
        },

        isMaintenance () {
            return this.incident.data[this.step].clazz === 'MaintenanceFileDto'
        },
    },

    watch: {
        incident () {
            this.filteredSites = this.sites;
        },

        sites () {
            this.filteredSites = this.sites;
        }
    },

    mounted() {
        this.filteredSites = this.sites;
    },

    methods: {
        onSearch () {
            this.filteredSites = this.sites.filter(unit => {
                if (!this.search) {
                    return true;
                }

                if (Core.filter.includes(unit.fabricNo, this.search)) {
                    return true;
                }

                if (Core.filter.includes(unit.zip, this.search)) {
                    return true;
                }

                if (Core.filter.includes(unit.street, this.search)) {
                    return true;
                }

                return !!Core.filter.includes(unit.city, this.search);
            })
        },

        onSelect (unit) {
            this.$emit("select", unit);
        },

        onRemove (unit) {
            this.$emit("remove", unit);
        },

        onCompact () {
            this.compact = !this.compact;
        },

        stepData (step) {
            return this.incident.data[step];
        },

        entry (unit, step) {
            return this.incident.data[step].collection.find (e => e.unit.id === unit.id);
        },



        bid (unit, step) {
            const stepData = this.incident.data[step];
            if (stepData.bids) {
                return stepData.bids[0];
            }

            return null;
        },

        borderType (index) {
            if (index === 0) {
                return "top";
            }

            if (index === this.filteredSites.length - 1) {
                return "bottom";
            }

            return "middle"
        }
    }
}
</script>

<style scoped>

.navigation-entries {
    border-radius: 10px!important;
    position: relative
}

.navigation-fab {
    position: absolute;
}

.scroll-area {
    max-height: 720px;
    overflow-y: scroll;
}

.step-name {
    font-size: 18px;
    font-weight: 600;
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

::v-deep .remove-button {
    padding-top: 4px;
    padding-left: 2px;
    width: 30px;
}

::v-deep .navigation-entry {
    font-size: 15px;
    min-height: 40px;
    border-radius: 0;
    display: flex;
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    padding-top: 3px;
}

::v-deep .elevator {
    width: calc(30% - 30px);
    max-width: calc(30% - 30px);
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

::v-deep .navigation-header {
    min-height: 25px;
    width: 700px;
    display: flex;
}

::v-deep .navigation-col-header {
    font-size: 12px;
    padding-left: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}


</style>